import React, { useEffect, useState } from "react";
import "../../index.css";

export default function UnsettledFees() {

  const STORAGE_KEY = "feeCollection";

  const toggleSelect = (row) => {
    setSelected(selected?.id === row.id ? null : row);
  };

  const [list, setList] = useState([]);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState(null);

  // LOAD + FILTER UNPAID
  useEffect(() => {
    const data = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    const unpaid = data.filter(l => l.status === "Unpaid");
    setList(unpaid);
  }, []);

  // SEARCH FILTER
  const filtered = list.filter(l =>
    l.studentName.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <>
      <style>{`
        .page { background:#f5f7fb; padding:20px; }
        .card { background:#fff; padding:15px; border-radius:8px; }

        .header { display:flex; justify-content:space-between; margin-bottom:10px; }

        .controls { display:flex; gap:10px; margin-bottom:10px; flex-wrap:wrap; }

        .search-box { padding:8px; border:1px solid #ccc; border-radius:4px; }

        .btn { padding:7px 12px; border:none; border-radius:4px; cursor:pointer; }
        .btn-dark { background:#2c3e50; color:white; }

        table { width:100%; border-collapse:collapse; }
        th, td { padding:10px; border-bottom:1px solid #eee; }

        tr:hover { background:#f4f6f9; cursor:pointer; }
        .active-row { background:#eef3ff; }
      `}</style>

      <div className="page">
        <div className="card">

          {/* HEADER */}
          <div className="header">
            <h3>Unsettled Fees</h3>
            <div>{filtered.length} Records</div>
          </div>

          {/* CONTROLS (same style) */}
          <div className="controls">
            <input
              className="search-box"
              placeholder="Search Student"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          {/* TABLE */}
          <table>
            <thead>
              <tr>
                <th></th>
                <th>Student</th>
                <th>Class</th>
                <th>Session</th>
                <th>Fee For</th>
                <th>Amount</th>
              </tr>
            </thead>

            <tbody>
              {filtered.length > 0 ? (
                filtered.map((l) => (
                  <tr
                    key={l.id}
                    className={selected?.id === l.id ? "active-row" : ""}
                    onClick={() => toggleSelect(l)}
                  >
                    <td>
                      <input
                        type="checkbox"
                        checked={selected?.id === l.id}
                        onChange={() => toggleSelect(l)}
                        onClick={(e) => e.stopPropagation()}
                      />
                    </td>

                    <td>{l.studentName}</td>
                    <td>{l.className}</td>
                    <td>{l.session}</td>
                    <td>{l.feeFor}</td>
                    <td>{l.amount}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" style={{ textAlign: "center" }}>
                    No Unsettled Fees
                  </td>
                </tr>
              )}
            </tbody>
          </table>

        </div>
      </div>
    </>
  );
}